<template>
  <div>
    <div class="sidebar">
      <nav class="sidebar-nav">

        <audio src="/static/audio/notification.mp3" preload="auto" id="player">
          <p>Your browser does not support the <code>audio</code> element.</p>
        </audio>

        <ul class="nav">
          <li class="nav-item" @click="checkFeature('dashboard');handleMenuClick($event)" v-if="$guser.isClinic($route)">
            <router-link :to="{ path: '/dashboard', query: $route.query }" class="nav-link" :class="{ 'no-feature': !isActive() }" ><i class="fa fa-area-chart"></i> {{$t('message.menu.dashboard')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!isActive()"></i> </router-link>
          </li>

          <li class="nav-item" @click="checkFeature('calendar');handleMenuClick($event)" v-if="$guser.isClinic($route)" @click.prevent="handleMenuClick">
            <router-link :to="{ path: '/appointment', query: { status: 'pending', ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="icon-clock"></i> {{$t('message.menu.appointment_pending')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> <span class="badge badge-danger" v-if="showPending">{{pendingSize}}</span></router-link>
          </li>

          <li class="nav-item" @click="checkFeature('calendar');handleMenuClick($event)" v-if="$guser.isClinic($route)">
            <router-link :to="{ path: '/appointments', query: { status: 'scheduled', viewType: 'daily', ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="icon-calendar"></i> {{$t('message.menu.appointments')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> </router-link>
          </li>
          <li class="nav-item" @click="checkFeature('calendar');handleMenuClick($event)" v-if="$guser.isDoctor()">
            <router-link :to="{ path: '/appointments', query: { status: 'scheduled', viewType: 'daily', ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="icon-calendar"></i> {{$t('message.menu.appointments')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> </router-link>
          </li>

          <li class="nav-item" @click="checkFeature('leave');handleMenuClick($event)" v-if="$guser.isClinic($route)">
            <router-link :to="{ path: '/clinic/leave', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !isActive() }"><i class="fa fa-calendar-times-o"></i> {{$t('message.menu.clinic_leave')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!isActive()"></i></router-link>
          </li>
          <li class="nav-item" @click="checkFeature('leave');handleMenuClick($event)" v-if="$guser.isDoctor()">
            <router-link :to="'/doctor/leave'" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="fa fa-calendar-times-o"></i> {{$t('message.menu.clinic_leave')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i></router-link>
          </li>
          <li v-if="$guser.isClinic($route)" class="nav-item" @click.prevent="handleMenuClick">
            <router-link :to="{ path: '/broadcast', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="fa fa-bullhorn"></i> {{$t('message.menu.sms_broadcast')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i></router-link>
          </li>
          <li class="nav-item" @click.prevent="handleMenuClick" v-if="$guser.isDoctor() || $guser.isClinic($route)">
            <router-link :to="{ path: '/article', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link"><i class="fa fa-file-o"></i> {{$t('message.menu.article')}} </router-link>
          </li>
          <li class="nav-item" @click="checkFeature('feedback');handleMenuClick($event)" v-if="$guser.isDoctor() || $guser.isClinic($route)" >
            <router-link :to="{ path: '/feedback', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="fa fa-comment-o"></i> {{$t('message.menu.feedback')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> </router-link>
          </li>
          <li class="nav-item" @click="checkFeature('report');handleMenuClick($event)"  v-if="$guser.isDoctor() || $guser.isClinic($route)">
            <router-link :to="{ path: '/report', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount() }"><i class="fa fa-bar-chart"></i> {{$t('message.menu.report')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> </router-link>
          </li>
          <li v-if="$guser.isClinic($route)" class="nav-item" @click="checkFeature('patient');handleMenuClick($event)">
            <router-link :to="{ path: '/patient', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !$guser.isPremiumAccount()}"><i class="fa fa-user"></i> {{$t('message.menu.patient')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i> </router-link>
          </li>

          <li v-if="$guser.isClinic($route)" tag="li" class="nav-item nav-dropdown active open" :to="{ path: ''}" disabled>
            <div class="nav-link nav-dropdown-toggle"><i class="fa fa-hospital-o"></i> {{$t('message.menu.clinic_info')}}</div>
            <ul class="nav-dropdown-items">
              <li class="nav-item" @click.prevent="handleMenuClick">
                <router-link :to="{ path: '/clinic/general', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link">{{$t('message.menu.clinic_information')}}</router-link>
              </li>
              <li class="nav-item" @click.prevent="handleMenuClick">
                <router-link :to="{ path: '/clinic/clinic_address', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link">{{$t('message.menu.clinic_address')}}</router-link>
              </li>
              <li class="nav-item" @click.prevent="handleMenuClick">
                <router-link :to="{ path: '/clinic/schedules', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" exact>{{$t('message.menu.clinic_schedule')}}</router-link>
              </li>
              <li class="nav-item" @click.prevent="handleMenuClick">
                <router-link :to="{ path: '/clinic/services', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" exact>{{$t('message.menu.clinic_services')}}</router-link>
              </li>
              <li class="nav-item" @click="checkFeature('settings');handleMenuClick($event)">
                <router-link :to="{ path: '/clinic/setting', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link" :class="{ 'no-feature': !isActive() }" exact>{{$t('message.menu.clinic_settings')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!isActive()"></i></router-link>
              </li>
            </ul>
          </li>

          <li v-if="$guser.isDoctor()" class="nav-item" @click.prevent="handleMenuClick">
            <router-link :to="'/doctor/step1/me'" class="nav-link"><i class="fa fa-user-md"></i> {{$t('message.menu.doctor')}} </router-link>
          </li>
          <li v-if="$guser.isDoctor()" class="nav-item" @click.prevent="handleMenuClick">
            <router-link :to="'/doctor/setting'" class="nav-link"><i class="fa fa-cog"></i> {{$t('message.menu.clinic_settings')}} </router-link>
          </li>
          <li v-if="$guser.isClinic($route)" class="nav-item" @click.prevent="handleMenuClick">
            <router-link :to="{ path: '/clinic/doctors', query: { ref_clinic_id: $route.query.ref_clinic_id } }" class="nav-link"><i class="fa fa-user-md"></i> {{$t('message.menu.doctors')}} </router-link>
          </li>
          <li v-if="$guser.isClinic($route)" class="nav-item" @click="handleMenuClick">
            <a :href="clinicUrl" target="_blank" class="nav-link"><i class="fa fa-external-link" aria-hidden="true"></i> {{$t('message.menu.clinic_view')}} </a>
          </li>
          <li v-if="$guser.isDoctor()" class="nav-item" @click="handleMenuClick">
            <a :href="doctorUrl" target="_blank" class="nav-link"><i class="fa fa-external-link" aria-hidden="true"></i> {{$t('message.menu.doctor_view')}} </a>
          </li>
          <li class="nav-item" @click='signout'>
            <a class='nav-link'><i class="fa fa-sign-out"></i> {{$t('message.menu.sign_out')}}</a>
          </li>
        </ul>
      </nav>
    </div>

    <sweet-modal icon="info" title="ฟังชั้นนี้ถูกปิดการใช้งานอยู่" ref="lockModal" overlay-theme="dark">
      <p>ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง</p>
      <button v-on:click="gotoPlanPage()" class="btn btn-add btn-lg btn-success"><i class="fa fa-key" aria-hidden="true" v-if="!isActive()"></i> Unlock</button>
    </sweet-modal>
  </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue'
import router from '@/router'

export default {
  name: 'sidebar',
  components: {
    SweetModal
  },
  data () {
    return {
      clinic: {},
      clinicUrl: (this.$guser.user.clinic ? this.$APP_CONFIG.api.domain + '/clinic/' + this.$guser.user.clinic.slug : ''),
      doctorUrl: (this.$guser.user.doctor ? this.$APP_CONFIG.api.domain + '/doctor/' + this.$guser.user.doctor.slug : ''),
      currentPending: 0
    }
  },
  firebase () {
    if (this.$guser.isClinic()) {
      return {
        notifications: {
          source: this.$rtdb.ref(`notifications/${this.$guser.user.clinic.id}`),
          asObject: true
        }
      }
    } else {
      return {}
    }
  },
  computed: {
    showPending () {
      return this.notifications != null && this.notifications.pendingAppointmentNumber != null && this.notifications.pendingAppointmentNumber > 0
    },
    pendingSize () {
      if (this.notifications != null && this.notifications.pendingAppointmentNumber != null) {
        if (this.notifications.pendingAppointmentNumber > this.currentPending) {
          this.player.play()
        }
        this.currentPending = this.notifications.pendingAppointmentNumber
        return this.notifications.pendingAppointmentNumber
      } else {
        return 0
      }
    }
  },
  methods: {
    handleClick (e) {
      /* e.preventDefault()
      e.target.parentElement.classList.toggle('open') */
    },
    handleMenuClick (e) {
      if (this.$ismobile()) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      }
    },
    async signout () {
      await this.$guser.signout()
      this.$router.push('/auth/login')
    },
    checkFeature (name) {
      if (!this.$guser.isPremiumAccount()) {
      // if (this.$guser.isClinic() && !this.isActive()) {
        // this.$toastr.error(this.$t('message.menu_message.in_active_feature'))
        // this.$router.push({path: '/package'})
        this.$refs.lockModal.open()
        return false
      }
      return true
    },
    gotoPlanPage () {
      this.$refs.lockModal.close()
      if (this.$guser.isClinic()) {
        router.push({'path': '/package', query: {'type': 'clinic'}})
      } else if (this.$guser.isDoctor()) {
        router.push({'path': '/package', query: {'type': 'doctor'}})
      }
    },
    isActive () {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1
    }
  },
  mounted () {
    this.player = document.getElementById('player')
  }
}
</script>

<style lang="scss">
.sweet-modal{
  .sweet-title > h2 {
    margin-top: 20px;
  }
} 
.sidebar {
  background-color: #2D3E70;

  .nav-link {
    cursor: pointer;
  }

  .nav-link i {
      color: #FFF !important;
  }

  .nav-item.nav-dropdown.open {
    background: transparent !important;
  }

  .nav-dropdown-items {
    background: rgba(0, 0, 0, 0.2) !important;
  }

  .nav-dropdown-items .nav-item a {
    padding-left: 3.4rem !important;
  }

  .no-feature {
    color: #8e8e8e !important;
    background-color: #545454 !important;
    pointer-events: none;
  }

  .no-feature i {
    color: #8e8e8e !important;
  }

  .menu-lock {
    float: right;
  }

}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?4ce83fe1